import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'

interface EmailArchiveModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  archive: {
    emails: Array<{
      timestamp: string
      metadata: {
        sent_at: string
        subject: string
        recipient: {
          name: string
          email: string
        }
      }
      content: {
        html: string
      }
    }>
  }
}

const EmailArchiveModal = ({ open, onOpenChange, archive }: EmailArchiveModalProps) => {
  if (!archive?.emails?.length) return null

  // Sort emails by timestamp (newest first)
  const sortedEmails = [...archive.emails].sort(
    (a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
  )

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Gönderilen Emailler ({sortedEmails.length})</DialogTitle>
        </DialogHeader>
        <div className="space-y-6">
          {sortedEmails.map((email, index) => (
            <div key={email.timestamp} className="border rounded">
              <div className="p-3 border-b bg-gray-50">
                <div className="flex justify-between items-start mb-2">
                  <div className="font-medium">Email #{sortedEmails.length - index}</div>
                  <div className="text-sm text-gray-500">
                    {new Date(email.metadata.sent_at).toLocaleString('tr-TR')}
                  </div>
                </div>
                <div className="text-sm space-y-1">
                  <div>
                    <span className="font-medium">Konu:</span> {email.metadata.subject}
                  </div>
                  <div>
                    <span className="font-medium">Alıcı:</span> {email.metadata.recipient.name} (
                    {email.metadata.recipient.email})
                  </div>
                </div>
              </div>
              <div className="p-4">
                <div dangerouslySetInnerHTML={{ __html: email.content.html }} />
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default EmailArchiveModal
